export default __webpack_public_path__ + "media/images/mailer-new/common/logo-footer-894c22dc9deb311dad853ca82df5b2cc.png";